import { render } from "./ExtentionsTab.vue?vue&type=template&id=52506a20&scoped=true"
import script from "./ExtentionsTab.vue?vue&type=script&lang=js"
export * from "./ExtentionsTab.vue?vue&type=script&lang=js"

import "./ExtentionsTab.vue?vue&type=style&index=0&id=52506a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52506a20"]])

export default __exports__